export default "__VITE_ASSET__$3gr1z7w__"